import { DataFeedInput } from '@server/data-feed/schemas/input.schema';
import { TradingFormState } from '../../widgets/trading-form/trading-form.types';
import { createScaleInConfig } from '../../widgets/trading-form/position-management-config.utils';

export const convertDataFeedConfigToFormState = (
  config: DataFeedInput
): TradingFormState => {
  const {
    marketConfig,
    positionManagementConfig,
    tradingScheduleConfig,
    timeframes
  } = config;

  return {
    marketConfig: {
      exchangeId: marketConfig.exchangeId,
      symbol: marketConfig.symbol,
      tradingMode: marketConfig.tradingMode,
      testnet: marketConfig.testnet
    },
    tradingScheduleConfig: {
      trade: tradingScheduleConfig?.trade,
      tradingWindowStart: tradingScheduleConfig?.tradingWindowStart,
      tradingWindowEnd: tradingScheduleConfig?.tradingWindowEnd
    },
    positionManagementConfig: {
      positionSize: positionManagementConfig!.positionSize,
      leverage: positionManagementConfig!.leverage,
      commissionPercent: positionManagementConfig?.commissionPercent,
      stopLoss: positionManagementConfig?.stopLoss,
      trailingStop: positionManagementConfig?.trailingStop,
      trailingStopPercent: positionManagementConfig?.trailingStopPercent,
      stopLossPercent: positionManagementConfig?.stopLossPercent,
      scalping: positionManagementConfig?.scalping,
      takeProfitLevels: positionManagementConfig?.takeProfitLevels?.map(
        ({ threshold, positionPercent }) => ({ threshold, positionPercent })
      ),
      scaleIn: positionManagementConfig?.scaleIn
        ? {
            enabled: positionManagementConfig.scaleIn.enabled ?? true,
            addSize: positionManagementConfig.scaleIn.addSize,
            minPriceStepFromLastSignalPercent:
              positionManagementConfig.scaleIn.minPriceStepFromLastSignalPercent,
            onlyInProfit: positionManagementConfig.scaleIn.onlyInProfit
          }
        : createScaleInConfig()
    },
    timeframes
  };
};
